;(function () {
  const fieldId = 5950
  function login(contactInfo) {
    WebEmarsysSdk.login(contactInfo).catch(err => {
      console.log(`[WebEmarsysSdk] Got an error during login: ${err.message}<br>Check console for details.`)
    })
  }

  function safeLogin(contactInfo) {
    WebEmarsysSdk.isLoggedIn()
      .then(result => {
        if (!result) login(contactInfo)
      })
      .catch(err => {
        console.log(`[WebEmarsysSdk] Got an error during safe login: ${err.message}<br>Check console for details.`)
      })
  }

  function logout() {
    WebEmarsysSdk.logout().catch(err => {
      console.log('[WebEmarsysSdk] Error during logout', err)
    })
  }

  // 用户登录后，自动绑定 Emarsys
  if (window.ShopifyCustomerId) {
    const contactInfo = { fieldId, fieldValue: window.ShopifyCustomerId }
    WebEmarsysSdk.push(() => safeLogin(contactInfo))
  } else {
    WebEmarsysSdk.push(logout)
  }
})()
